
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","width":"31","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"fill":"#224DBA","width":"30.8","height":"22","rx":"3.316"}}),_c('path',{attrs:{"d":"M10.494 14.673H8.689l-1.353-5.28c-.065-.243-.201-.457-.402-.559a5.786 5.786 0 00-1.654-.558v-.204h2.908c.4 0 .702.306.752.66l.702 3.809 1.804-4.469h1.755l-2.707 6.601zm3.71 0H12.5l1.403-6.6h1.705l-1.404 6.6zm3.609-4.772c.05-.356.351-.559.702-.559a3.115 3.115 0 011.655.305l.3-1.422a4.231 4.231 0 00-1.554-.305c-1.654 0-2.858.914-2.858 2.183 0 .966.853 1.473 1.455 1.778.651.304.902.508.852.812 0 .457-.502.66-1.003.66a4.22 4.22 0 01-1.754-.406l-.301 1.422a4.823 4.823 0 001.855.355c1.855.05 3.008-.863 3.008-2.234 0-1.727-2.357-1.828-2.357-2.59zm8.322 4.772l-1.353-6.6h-1.454a.755.755 0 00-.702.507l-2.507 6.093h1.755l.35-.964h2.156l.201.964h1.554zM23.58 9.85l.5 2.488h-1.403l.903-2.488z","fill":"#FFF"}})])])
          )
        }
      }
    